import React from 'react';
import PropTypes from 'prop-types';
import withModal from '../../Modal/WithModal';
import { ViewerPrimaryColorUserStyle } from '../../UserCustomization';
import { exportBrochures, exportList, exportAreas, exportExcel, exportRFI } from '../../../ajax/endpoints';
import svgInline from '../../SvgInline/SvgInline';
import closeIcon from '../../../shared/assets/icon-close.svg';

import './ExportModal.css';

class ExportModal extends React.Component {
  generate() {
    const {
      buildings,
      sites,
      states,
      regions,
      counties,
      communities,
      organizationId,
      onModalClick } = this.props;

    const type = this.reportType.value;
    const subType = this.subReportType && this.subReportType.value;

    if (type === 'brochures') {
      window.open(exportBrochures(
        { buildings, sites, states, regions, counties, communities, organizationId },
      ));
    } else if (type === 'listing') {
      window.open(exportList({ buildings, sites, organizationId, isTour: false }));
    } else if (type === 'tour') {
      window.open(exportList({ buildings, sites, organizationId, isTour: true }));
    } else if (type === 'area') {
      window.open(exportAreas(subType, { states, regions, counties, communities }));
    } else if (type === 'excel') {
      window.open(exportExcel({ buildings, sites, organizationId }));
    } else if (type === 'rfi') {
      const projectTitle = this.projectTitle && this.projectTitle.value;
      window.open(exportRFI({ projectTitle, buildings, sites, organizationId }));
    }

    onModalClick();
  }

  hasAreas() {
    const { states, regions, counties, communities } = this.props;

    return states.length || regions.length || counties.length || communities.length;
  }

  render() {
    const {
      onModalClick,
    } = this.props;

    const projectTitleDisplay = this.reportType && this.reportType.value === 'rfi'
      ? {}
      : { display: 'none' };

    return (
      <div className="modal-wrapper export-modal">
        <div className="export-modal-header">
          <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
            <div className="modal-header">
              <h2 className="modal-title">Reports</h2>
              <a tabIndex="0" onClick={onModalClick}>
                <div className="modal-close">
                  {svgInline(closeIcon)}
                </div>
              </a>
            </div>
          </ViewerPrimaryColorUserStyle>
        </div>
        <div className="modal-body export-modal-form">
          <h4>
            Report Type
          </h4>
          <div className="form-group">
            <select
              ref={input => { this.reportType = input; }}
              onChange={() => { this.forceUpdate(); /* for subReportType select */ }}
            >
              <option value="brochures">PDF Brochure for Properties and Areas</option>
              <option value="tour">Property Tour PDF</option>
              <option value="listing">Property List PDF</option>
              {
                this.hasAreas() &&
                <option value="area">ESRI Area Reports</option>
              }
              <option value="excel">Buildings and Sites as Excel (.xls)</option>
              <option value="rfi">RFI for Buildings and Sites</option>
            </select>
          </div>

          {this.reportType && this.reportType.value === 'area' && (
            <select defaultValue="census2010_profile" ref={input => { this.subReportType = input; }}>
              <option value="business_summary">Business Summary</option>
              <option value="community_profile">Community Profile</option>
              <option value="market_profile">Market Profile</option>
              <option value="graphic">Graphic Profile</option>
              <option value="housing">Housing Profile</option>
              <option value="dandi">Demographic and Income Profile</option>
              <option value="census2010_profile">2010 Census Profile</option>
            </select>
          )}

          <div className="form-group" style={projectTitleDisplay}>
            <label htmlFor="projectTitle">Project Title</label>
            <input
              type="text"
              id="projectTitle"
              ref={input => { this.projectTitle = input; }}
              onChange={() => { this.forceUpdate(); }}
            />
          </div>

          <div className="export-modal-generate">
            <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
              <button
                type="button"
                onClick={() => { this.generate(); }}
                className="btn pull-left"
                disabled={this.reportType && this.reportType.value === 'rfi' && this.projectTitle && !this.projectTitle.value}
              >
                EXPORT REPORT
              </button>
            </ViewerPrimaryColorUserStyle>
          </div>
        </div>
      </div>
    );
  }
}

ExportModal.propTypes = {
  onModalClick: PropTypes.func,
  buildings: PropTypes.arrayOf(PropTypes.object),
  sites: PropTypes.arrayOf(PropTypes.object),
  states: PropTypes.arrayOf(PropTypes.object),
  regions: PropTypes.arrayOf(PropTypes.object),
  counties: PropTypes.arrayOf(PropTypes.object),
  communities: PropTypes.arrayOf(PropTypes.object),
  organizationId: PropTypes.string,
};

export default withModal(ExportModal, 'export-modal');



// WEBPACK FOOTER //
// ./src/components/Favorites/ExportModal/ExportModal.js